import React, { useState } from 'react'
import { connect } from 'react-redux'
import * as ReactBootstrap from 'react-bootstrap'
import ResetPasswordForm from './ResetPasswordForm'
import * as components from '../../components'
import { AuthenticationService } from '../../services'
import { useSelector } from 'react-redux'
export const ResetPasswordConfirm = (props) => {
  const [response, setResponse] = useState(null)
  const [loading, setLoading] = useState(null)
  const [error, setError] = useState(null)
  const { productName } = useSelector((state) => state.application)

  const ResetPasswordFormWithData = connect((state) => ({
    initialValues: props,
  }))(ResetPasswordForm)

  const extractError = (errors) => {
    const data = errors && errors.response && errors.response.data
    if (!data) {
      return 'Could not reset your password. Please try again.'
    }
    // The reset-confirm endpoint reports field errors (e.g. a reused
    // password under new_password1, or an invalid uid/token).
    const firstKey = ['new_password1', 'new_password2', 'token', 'uid'].find(
      (key) => Array.isArray(data[key]) && data[key].length
    )
    if (firstKey) {
      return data[firstKey][0]
    }
    return data.detail || 'Could not reset your password. Please try again.'
  }

  const changePassword = (values) => {
    setLoading(true)
    setError(null)
    AuthenticationService.resetPassword(values).then(
      (response) => {
        setLoading(false)
        setResponse(response)
      },
      (errors) => {
        setLoading(false)
        setError(extractError(errors))
      }
    )
  }
  return (
    <div className="vh-100 loginBackGround">
      <div className="pt-5 mx-auto col-sm-8 col-md-4">
        {loading && <components.Loading />}
        {!loading && !response && (
          <div>
            <ReactBootstrap.Card>
              <ReactBootstrap.Card.Body>
                <ReactBootstrap.Card.Title>
                  Reset Password for {productName}
                </ReactBootstrap.Card.Title>
                <ReactBootstrap.Card.Subtitle className="mt-3 mb-3 text-muted">
                  Please enter your desired password
                </ReactBootstrap.Card.Subtitle>

                {error && (
                  <div className="alert alert-danger" role="alert">
                    {error}
                  </div>
                )}
                <ResetPasswordFormWithData onSubmit={changePassword} />
              </ReactBootstrap.Card.Body>
            </ReactBootstrap.Card>
          </div>
        )}
        {!loading && response && (
          <div>
            <div class="card bg-success text-white">
              <div class="card-body text-center">
                {response && response.detail}
              </div>
            </div>{' '}
          </div>
        )}
      </div>
    </div>
  )
}
